import ScrollBooster from 'scrollbooster';

export default function () {

  document.addEventListener('DOMContentLoaded', function(){
    // タブにクリックイベントを付与
    const tabs = document.getElementsByClassName('tab');
    for(let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', tabSwitch, false);
    }

    // 1番目のパネルだけ可視化
    const panels = document.getElementsByClassName('panel');
    for(let i = 0; i < panels.length; i++) {
      panels[i].classList.remove('is-show');
    }
    panels[0].classList.add('is-show');

    // タブの切り替え
    function tabSwitch(){
      document.getElementsByClassName('is-active')[0].classList.remove('is-active');
      this.classList.add('is-active');
      document.getElementsByClassName('is-show')[0].classList.remove('is-show');
      const arrayTabs = Array.prototype.slice.call(tabs);
      const index = arrayTabs.indexOf(this);
      document.getElementsByClassName('panel')[index].classList.add('is-show');
    }
  }, false);
}

